import Logo from 'components/common/Logo';
import { PropsWithChildren } from 'react';
import { Carousel, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import image0 from 'assets/img/bg/flir0.jpeg'
import image1 from 'assets/img/bg/flir1.jpeg'
import image2 from 'assets/img/bg/flir2.jpeg'
import image3 from 'assets/img/bg/flir3.jpeg'
import image4 from 'assets/img/bg/flir4.jpeg'
import image5 from 'assets/img/bg/flir5.jpeg'
import image6 from 'assets/img/bg/flir6.jpeg'
import image7 from 'assets/img/bg/flir7.jpeg'
import image8 from 'assets/img/bg/flir8.jpeg'
import image9 from 'assets/img/bg/flir9.jpeg'
import image10 from 'assets/img/bg/flir10.jpeg'

interface AuthSplitLayoutProps {
  logo?: boolean;
  bg: string;
}

const AuthSplitLayout = ({
  logo = true,
  bg,
  children
}: PropsWithChildren<AuthSplitLayoutProps>) => {
  return (
    <Row className="vh-100 g-0">
      <Col lg={7} className="position-relative d-none d-lg-block">

        <Carousel
          fade={true}
          slide={true}
          controls={false}
          interval={2500}
          indicators={false}
        >
          {([image0, image1, image2, image3, image4, image5, image6, image7, image8, image9, image10] as string[]).map((img, idx) => (
            <Carousel.Item key={idx}>
              <img className="d-block w-100 vh-100" src={img} />
            </Carousel.Item>
          ))}

        </Carousel>

      </Col>
      <Col lg={5}>
        <Row className="flex-center h-100 g-0 px-4 px-sm-0">
          <Col sm={6} lg={7} xl={6}>
            {logo && (
              <div className="text-center">
                <Link
                  to="/"
                  className="d-inline-block text-decoration-none mb-4"
                >
                  <Logo
                    text={false}
                    width={150}
                    className="fw-bolder fs-5 d-inline-block"
                  />
                </Link>
              </div>
            )}
            {children}
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default AuthSplitLayout;
